import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import classes from "../../Top/Top.module.scss";

// 投稿データに関するインターフェース
interface Post {
    id: number;
    title: { rendered: string };
    link: string;
  }

  const TopNews: React.FC<{ categoryId: number }> = ({ categoryId }) => {
    const [posts, setPosts] = useState<Post[]>([]);

    const stripHtml = (html: string) => {
        const tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
      };
    
      const limitText = (text: string, limit: number) => {
        const plainText = stripHtml(text);
        return plainText.length > limit ? plainText.substring(0, limit) + "..." : plainText;
      };
    
    useEffect(() => {
      fetch(`https://hado-official.com/wp-json/wp/v2/posts?categories=${categoryId}&per_page=3`)
        .then((response) => response.json())
        .then((data) => setPosts(data))
        .catch((error) => console.error('Error fetching data:', error));
    }, [categoryId]);
  
    return (
      <ul className={classes.newsList}>
        {posts.map((post, index) => (
          <li key={index} className={classes.newsItem}>
            <Link to={`/post/${post.id}`}>
            <p>{limitText(post.title.rendered, 100)} </p>
            </Link>
          </li>
        ))}
      </ul>
    );
  };
  

  export default TopNews;